import { UpdateIconButton, pn, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@compass/core";
import { ListBeProperty } from "components";
import { Permission, PermissionAction, SimpleDto, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { postHSPlanStatusPageRoute } from "../PostHSPlanStatus/PostHSPlanStatus"; 
import { PostHSPlanStatusListResource } from "generated/openApi";

export const PostHSPlanStatusTable = (props: {
    rootPermission: Permission;
    tableContainerRef: React.RefObject<HTMLDivElement>;
    postHSPlanStatuss: SimpleDto[];
    setPostHSPlanStatuss: (PostHSPlanStatuss: SimpleDto[]) => void;
    resource: PostHSPlanStatusListResource;
    searchFocused: boolean;
    sortObjects: SortObject[] | undefined;
    sort: (sortObjects: SortObject[]) => void;
    loadList: () => void;
}) => {
    const navigate = useNavigate();
    const properties = props.resource.properties || [];

    return (
        <TableContainer ref={props.tableContainerRef}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "7%"}}>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<SimpleDto>("id"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<SimpleDto>("name"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell type="action"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.postHSPlanStatuss.map((postHSPlanStatusItem) => (
                        <TableRow
                            key={postHSPlanStatusItem.id}
                            onClick={() =>
                                navigate(
                                    postHSPlanStatusPageRoute.getPath({
                                        id: postHSPlanStatusItem.id,
                                        crudMode: "view",
                                        screenType: "dialog"
                                    })
                                )
                            }
                        >
                            <TableCell>{postHSPlanStatusItem.id}</TableCell>
                            <TableCell>{postHSPlanStatusItem.name}</TableCell>
                            <TableCell type="action">
                                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                                    <UpdateIconButton color="primary"
                                        onClick={() =>
                                            navigate(
                                                postHSPlanStatusPageRoute.getPath({
                                                    id: postHSPlanStatusItem.id,
                                                    crudMode: "edit",
                                                    screenType: "dialog"
                                                })
                                            )
                                        }
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};